/**
 * GH#2765 (c) — el SUPER_ADMIN no es un usuario de los módulos de agencia (TENANT FIRST: el administrador de plataforma no navega dentro
 * de un tenant como si fuera de él). Su sesión vive en el slot de `/admin` (`inbo_admin_auth_token`) y el login normal la rechaza, así que
 * fuera de `/admin` el usuario de agencia es `null`: el menú lateral sale vacío y la cabecera dice «Usuario» (medido por CAC en `/erp/dashboard`).
 * Quien cae ahí vuelve al panel de administración. Impersonando hay un usuario de agencia (el destino), por eso no se redirige.
 */
export interface EstadoDeSesion {
  /** La ruta empieza por `/admin`. */
  isAdminRoute: boolean;
  /** Hay un usuario en la sesión normal (agencia, o el destino de una impersonación). */
  hayUsuarioDeAgencia: boolean;
  /** Hay sesión en el slot de administración. */
  adminAutenticado: boolean;
  adminRole?: string;
}

export function debeVolverAlPanelAdmin({ isAdminRoute, hayUsuarioDeAgencia, adminAutenticado, adminRole }: EstadoDeSesion): boolean {
  return !isAdminRoute && !hayUsuarioDeAgencia && adminAutenticado && adminRole === 'SUPER_ADMIN';
}
